const observer = typeof window === 'undefined' ? null : typeof IntersectionObserver !== 'undefined'
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const { desktop, mobile, duration = 1000 } = el._lazyBgOptions;
        const url = window.matchMedia('(max-width: 749px)').matches ? mobile : desktop;

        const img = new Image();
        img.onload = () => {
          el.style.backgroundImage = `url(${url})`;
          if (duration === 0) return;
          el.style.transition = `opacity ${duration}ms ease`;
          requestAnimationFrame(() => {
            el.style.opacity = '1';
          });
        };
        img.src = url;

        observer.unobserve(el);
      });
    }, {
      rootMargin: '200px',
    })
  : null;

export function lazyBg(el, options = {}) {
  el._lazyBgOptions = options;
  el.style.opacity = '0';
  if (observer) observer.observe(el);
}
